import getConfig from 'next/config';
import jsCookie from 'js-cookie';
import utm from '../utils/utm';
import { TomiAi } from '../utils/tomi.ai';

import { HTTPClient } from './api';
import { LEADFORM_SOURCE } from './constant';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;
const { HUBSPOT_FORM_ENDPOINT } = getConfig().serverRuntimeConfig;

export const sendToHubspot = async (data) => {
  const UTM = utm.getAll();
  const hasUTM = Object.keys(UTM).length > 0;

  const hubspotPayload = {
    fields: [
      { name: 'full_name', value: data.fullName ? data.fullName : '' },
      {
        name: 'number_of_employees',
        value: data.number_of_employees ? data.number_of_employees : '',
      },
      { name: 'phone', value: data.phoneNumber },
      { name: 'company', value: data.company },
      { name: 'email', value: data.email },
      { name: 'category', value: data.category },
      { name: 'utm_source', value: hasUTM && Object.keys(UTM.utm_source) ? UTM.utm_source : '' },
      {
        name: 'utm_campaign',
        value: hasUTM && Object.keys(UTM.utm_campaign) ? UTM.utm_campaign : '',
      },
      { name: 'utm_medium', value: hasUTM && Object.keys(UTM.utm_medium) ? UTM.utm_medium : '' },
      {
        name: 'utm_content',
        value: hasUTM && Object.keys(UTM.utm_content) ? UTM.utm_content : '',
      },
    ],
    context: {
      pageUri: BASE_URL_MEDIA,
      pageName: 'Lifepal Media',
    },
  };

  const hubspotRequest = {
    method: 'POST',
    body: JSON.stringify(hubspotPayload),
  };

  return await HTTPClient(HUBSPOT_FORM_ENDPOINT, hubspotRequest);
};

export const sendLeads = async (data, isInarticleLeadform) => {
  let UTM = utm.getAll();
  const gaId = TomiAi.getGaId();
  const landing_page = jsCookie.get('landing_page');

  if (gaId) {
    UTM.ga_id = gaId;
  }

  if (isInarticleLeadform) {
    UTM.campaign = 'QUEEN_InarticleLeadForm';
    UTM.source = 'media';
    UTM.medium = 'inarticle_leadform';
    UTM.ad_content = window.location.pathname;
  }

  const payload = {
    category: data.category,
    phone_number: data.phoneNumber,
    ...(data.email ? { email: data.email } : {}),
    ...(data.firstName ? { first_name: data.firstName } : {}),
    ...(data.lastName ? { last_name: data.lastName } : {}),
    lead_info_data: {
      ...(data.age ? { age: data.age.toString() } : {}),
      ...(data.gender ? { gender: data.gender } : {}),
      ...(data.email ? { email: data.email } : {}),
      ...(LEADFORM_SOURCE ? { source: LEADFORM_SOURCE } : {}),
      ...(landing_page ? { landing_page } : {}),
      conversion_page: `${window.location.host}${window.location.pathname}`,
    },
    ...(Object.keys(UTM).length ? { utm_data: UTM } : {}),
  };

  return await HTTPClient(`${BASE_URL_MEDIA}api/leads/leads/`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};


export const sendToZendesk = async (data) => {
  const phoneNumber = data.phoneNumber.replace(/ +/g, '');
  const payload = {
    fullName: data.fullName,
    phoneNumber: phoneNumber,
    category: data.category,
    insuranceBrand: data.insuranceBrand,
    subscription: data.subscription,
  };

  return await HTTPClient(`${BASE_URL_MEDIA}api/zendesk/create-ticket/`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};
